import { PropsWithChildren } from "react";
import { IonChip } from "@ionic/react";
import { Icon } from "swing-components";

/**
 * FilterChip is a toggleable chip component that has an
 * active/inactive st ate set with `selected`
 *
 * `showDismiss` decides whether or not to show the dismissable
 * "X" button if the Chip is selected.
 *
 * Figma: https://www.figma.com/design/uJsnuoosxqn26Rot52zCXZ?node-id=14053-3306&main-component=1&state-group-id=14053-3308&m=dev&fuid=1099366387130018374
 *
 */
type FilterChipProps = {
  selected: boolean;
  showDismiss?: boolean;
  onClick: () => void;
} & PropsWithChildren;

export function FilterChip(props: FilterChipProps) {
  const { selected, showDismiss, onClick, children } = props;

  return (
    <IonChip
      onClick={onClick}
      css={{
        fontWeight: selected ? "bold" : undefined,
        width: "max-content",
        background: selected ? "var(--swing-blue300)" : "var(--swing-white200)",
        border: "2px solid",
        borderColor: selected ? "var(--swing-blue500)" : "var(--swing-slate400)",
        borderRadius: 999,
        padding: "0 8px",
        margin: 0,
      }}
    >
      {children} {selected && showDismiss && <Icon name="Close" />}
    </IonChip>
  );
}
